module.exports = __webpack_public_path__ + "media/images/lb/686-efdbbf8cc2e636d564d6c2330f0d3914.svg";